import { zipRegex } from '../../components/order-details/util/general';
export var onPhoneNumberChange = function (event, setPhoneNumber) {
    if (zipRegex.test(event.target.value.replace(/-/g, '')) ||
        event.target.value === '') {
        var rawValue = event.target.value.replace(/-/g, ''); // Remove existing hyphens
        var formattedValue = '';
        if (rawValue.length <= 3) {
            formattedValue = rawValue; // No hyphen for the first 3 characters
        }
        else if (rawValue.length <= 6) {
            formattedValue = "".concat(rawValue.slice(0, 3), "-").concat(rawValue.slice(3)); // Add one hyphen after the first 3 characters
        }
        else {
            formattedValue = "".concat(rawValue.slice(0, 3), "-").concat(rawValue.slice(3, 6), "-").concat(rawValue.slice(6)); // Add hyphens after the first 3 and next 3 characters
        }
        setPhoneNumber(formattedValue);
    }
};
